import React from 'react'
import PropTypes from 'prop-types'
import { useEnvValue, useShouldConditionallyRender } from '@morningtrain/react-helpers'

function ShowIfEnvValueMatches ({ name, matches, negate = false, children }) {

  const [value] = useEnvValue(name)
  const [shouldRender] = useShouldConditionallyRender(value, matches, negate)

  return React.Children.map(children, child => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, {
        style: {
          display: shouldRender ? 'block' : 'none',
        }
      })
    }
    return child
  })
}

ShowIfEnvValueMatches.propTypes = {
  name: PropTypes.string.isRequired,
}

export default ShowIfEnvValueMatches
